import axios from 'axios';

export default {
  codility: {
    getTests(parameters) {
      return axios.get('codility/tests', { params: parameters });
    },
    getTestLinks(applicationId) {
      return axios.get(`applications/${applicationId}/tests/codility`);
    },
    generateLink({ applicationId, testId }) {
      return axios.post(
        `applications/${applicationId}/tests/codility/generate`,
        { test_id: testId }
      );
    },
    getResult(parameters) {
      return axios.get('codility/tests/result', { params: parameters });
    },
    downloadResult(parameters) {
      return axios.get('codility/tests/result/pdf', {
        params: parameters,
        responseType: 'blob',
      });
    },
  },
  english: {
    getTestLinks(applicationId) {
      return axios.get(`applications/${applicationId}/tests/english`);
    },
    generateLink({ applicationId }) {
      return axios.post(`applications/${applicationId}/tests/english/generate`);
    },
  },
};
